module.exports = {
    name: 'Jürgen van Dijk',
    email: 'jurgen@activecreations.nl',
    comments: "Test\nNieuwe regel <b>tëst</b>",
    phonenumber: '038-3869367',
};



// WEBPACK FOOTER //
// ./assets/app/js/forms/dummy-formdata.js